<template>
    <svg class="star-icon" :class="{ 'star-icon_active': active }" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.91L12 17.77 5.82 21.05 7 14.14 2 9.27l6.91-1.01L12 2z" />
    </svg>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
.star-icon {
    width: 60px;
    height: 60px;
    fill: #ccc;
    cursor: pointer;
    transition: fill 0.2s;

    &:hover {
        fill: #f5a623;
    }

    &_active {
        fill: #f5a623;
    }
}
</style>
